module.exports = __webpack_public_path__ + "static/1984-1-a7d0d737afb8d241ed9736716101a142.png";